import { InjectionToken } from '@angular/core';

export const MP_MODAL_DATA = new InjectionToken<unknown>('MP_MODAL_DATA');
